import React, {Component} from 'react';
import {checkEmailAvailability, checkEmailAvailabilityNotIn, request} from "../../util/APIUtils";
import {deepCopyObject, filterCities, getCitySubdivisions, showAxiosError, trimObject} from "../../util/Helpers";
import {DatePicker, Form, input, Switch} from "antd";
import Select from "../../local_node_modules/react-select"
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import moment from "moment";
import {Label, Modal, ModalBody, ModalHeader, UncontrolledTooltip} from "reactstrap";
import './MemberList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import Maskedinput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";
import Uploader2 from "../../components/Uploader/Uploader2";
import 'react-datetime/css/react-datetime.css';
import _ from 'lodash';
import InActivateMemberModal from "./InActivateMemberModal";

const {TextArea} = input;

class MemberCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: false,
            citySelectionDisabled: false,
            mode: this.props.mode,
            outstandingAccruals: [],
            // isPassiveAllowed: false,
            inActivateMemberModal: false,
            isPreviouslyInactivated: false,
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                eskiSoyad: "",
                tcKimlikNo: "",
                dogumTarihi: null,
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: null,
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                belgeTuru: "",
                mezuniyetTarihi: null,
                diplomaNo: "",
                gozRuhTarih: null,
                gozRuhNo: "",
                gozRuhKurum: "",
                ruhsatTarihi: null,
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                fotoThumbFile: "",
                calismaBelgesiFile: "",
                uyelikDurdurmaDilekceFile: "",
                taahhutBelgesiFile: "",
                taahhutBelgesiThumbFile: "",
                taahhutBelgesiPath: "",
                kimlikCuzdanThumbFile: "",
                adliSicilThumbFile: "",
                ruhsatnameThumbFile: "",
                diplomaThumbFile: "",
                ikametgahThumbFile: "",
                calismaBelgesiThumbFile: "",
                uyelikDurdurmaDilekceThumbFile: "",
                fotoPath: "",
                kimlikCuzdanPath: "",
                adliSicilPath: "",
                ruhsatnamePath: "",
                diplomaPath: "",
                ikametgahPath: "",
                calismaBelgesiPath: "",
                uyelikDurdurmaDilekcePath: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: true,
                uyelikAktif: true,
                borcuVar: false,
                uyeCalisiyor: true,
                taahhut: false,
                kendiIsyeri: false,
                mesulMudur: false,
                kamuPersoneli: false,
                eczaci: false,
                temsilci: false,
                unemployed: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                username: "",
                email: "",
                cinsiyet: "",
                muesseseAdi: "",
                muesseseSahibi: "",
                isTransferred: false,
                calismaBelgeli: false,
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                },
                addressList: [
                    {
                        id: null,
                        addressType: 'PERMANENT',
                        addressString: null,
                        semt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null,
                    },
                    {
                        id: null,
                        addressType: 'WORK',
                        addressString: null,
                        semt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: null
                    }
                ]
            },
            fileInfo: {
                kimlikCuzdanFileName: "kimlikCuzdanFile",
                adliSicilFileName: "adliSicilFile",
                ruhsatnameFileName: "ruhsatnameFile",
                diplomaFileName: "diplomaFile",
                ikametgahFileName: "ikametgahFile",
                fotoFileName: "fotoFile",
                calismaBelgesiFileName: "calismaBelgesiFile",
                uyelikDurdurmaDilekceFileName: "uyelikDurdurmaDilekceFile",
                taahhutBelgesiFileName: "taahhutBelgesiFile"
            },
            permanentAdrsCities: null,
            workAdrsCities: null,
            permanentAdrsCitySubdivisions: null,
            workAdrsCitySubdivisions: null,
        };

        this.saveMember = this.saveMember.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeMember = this.onChangeMember.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onCityInfoChange = this.onCityInfoChange.bind(this);
        this.onChangeCheck = this.onChangeCheck.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
        this.validateEmailClass = this.validateEmailClass.bind(this);
        this.validateEmailField = this.validateEmailField.bind(this);
        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
        this.checkTransferState = this.checkTransferState.bind(this);
        this.onChangeUnemployedCheck = this.onChangeUnemployedCheck.bind(this);/*
        this.checkOutstandingAccruals = this.checkOutstandingAccruals.bind(this);
        this.listOutstandingAccruals = this.listOutstandingAccruals.bind(this);*/
    }

    componentDidMount() {
        if (this.state.mode === 'review') {
            this.setState({fieldsDisabled: true});
        }
        if (this.props.selectedMember) {
            let citySelectionDisabled = true;
            let selectedMember = deepCopyObject(this.props.selectedMember);
            let permanentAdrsCitySubdivisions = (selectedMember.addressList.length > 0) ? getCitySubdivisions(selectedMember.addressList[0].cityId, this.props.citySubdivisions) : null;
            let workAdrsCitySubdivisions = (selectedMember.addressList.length > 0) ? getCitySubdivisions(selectedMember.addressList[1].cityId, this.props.citySubdivisions) : null;
            let permanentAdrsCities = filterCities(this.props.cities, 1000);
            let workAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
            let isPreviouslyInactivated = !selectedMember.uyelikAktif;

            if (selectedMember.addressList.length === 0) {
                selectedMember.addressList.push({
                        id: null,
                        addressType: 'PERMANENT',
                        addressString: null,
                        semt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: selectedMember.id,
                    },
                    {
                        id: null,
                        addressType: 'WORK',
                        addressString: null,
                        semt: null,
                        cityId: null,
                        citysubdivisionId: null,
                        memberId: selectedMember.id,
                    });
            }
            (selectedMember.belgeTuru === "" || selectedMember.belgeTuru === null) ? selectedMember.belgeTuru = 'DIPLOMA' : selectedMember.belgeTuru;
            selectedMember.odaKayitTarihi = (selectedMember.odaKayitTarihi !== null && selectedMember.odaKayitTarihi !== "") ? moment.utc(selectedMember.odaKayitTarihi, "YYYY-MM-DD") : null;

            this.setState({
                memberInfo: selectedMember,
                citySelectionDisabled,
                permanentAdrsCitySubdivisions,
                workAdrsCitySubdivisions,
                permanentAdrsCities,
                workAdrsCities,
                isPreviouslyInactivated
            });
            if (selectedMember.isTransferred === true) {
                this.setState({fieldsDisabled: true});
            }
            this.getUserInfo();
            // this.listOutstandingAccruals();
        } else {
            let permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, 1000);
            let workAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
            this.setState({permanentAdrsCities, workAdrsCities});
        }

    }

    getUserInfo() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/user/id/" + this.props.selectedMember.user_id,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let userInfo = response.data;
                self.setState({
                    userInfo,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    checkTransferState() {
        if (this.state.memberInfo.transferTo !== undefined && this.state.memberInfo.transferTo !== null) {
            let msg = "Üyenin Bekleyen Transfer İşlemi Bulunmaktadır. Üyelik Durumu Değiştirilemez!";
            Alert.error(msg, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 10000
            });
            return true;
        }
        return false;
    }

    /*listOutstandingAccruals() {
        let self = this;
        let isPassiveAllowed = false;
        let params = {
            url: API_BASE_URL + "/accrual/outstandingAccruals/" + this.props.selectedMember.id,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let outstandingAccruals = response.data;
                if (Array.isArray(outstandingAccruals) && outstandingAccruals.length === 0) {
                    isPassiveAllowed = true;
                }
                self.setState({isPassiveAllowed});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }*/

   /* checkOutstandingAccruals(value) {
        if (!value) {
            if (!this.state.isPassiveAllowed) {
                return true;
            }
        }
        return false;
    }*/

    onChangeUnemployedCheck(name, value) {
        let memberInfo = _.cloneDeep(this.state.memberInfo);
        let addressList = memberInfo.addressList;
        let permanentAdrsCities = null;
        let permanentAdrsCitySubdivisions = null;
        memberInfo[name] = value;

        if (name === 'unemployed') {
            permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : (value) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
            permanentAdrsCitySubdivisions = null;
            addressList[0]['cityId'] = null;
            addressList[0]['citysubdivisionId'] = null;

            if (value) { //üye işsize alınırsa tüm iş yeri bilgilerini boş olarak set  et
                memberInfo['kendiIsyeri'] = false;
                memberInfo['mesulMudur'] = false;
                memberInfo['kamuPersoneli'] = false;
                memberInfo['eczaci'] = false;
                memberInfo['temsilci'] = false;
                memberInfo['unemployed'] = true;
                memberInfo['muesseseSahibi'] = null;
                memberInfo['muesseseAdi'] = null;
                memberInfo['isTel'] = null;
                memberInfo['vergiDairesiAd'] = null;
                memberInfo['vergiNo'] = null;
                memberInfo['ruhsatNo'] = null;
                memberInfo['ruhsatTarihi'] = "";
                addressList[1]['citysubdivisionId'] = null;
                addressList[1]['cityId'] = null;
                addressList[1]['addressString'] = null;
                addressList[1]['semt'] = null;
            }
            console.log(memberInfo, addressList);
        }
        this.setState({memberInfo, permanentAdrsCities, permanentAdrsCitySubdivisions});
    }

    onChangeCheck(name, value) {
        let memberInfo = _.cloneDeep(this.state.memberInfo);

        if (this.checkTransferState()) {
            return;
        }

        /*if (name === 'uyelikAktif' && !value)
            if (this.checkOutstandingAccruals(value)) {
                memberInfo["borcuVar"] = true;
            }*/

        let addressList = memberInfo.addressList;
        let permanentAdrsCities = null;
        let permanentAdrsCitySubdivisions = null;

        memberInfo[name] = value;

        if (name === 'uyeCalisiyor') {
            permanentAdrsCities = (this.props.currentUser.realm === 0) ? filterCities(this.props.cities, 1000) : (value) ? filterCities(this.props.cities, 1000) : filterCities(this.props.cities, this.props.currentUser.realm);
            permanentAdrsCitySubdivisions = null;
            addressList[0]['cityId'] = null;
            addressList[0]['citysubdivisionId'] = null;

            if (!value) { //çalışma durumu pasife çekilirse tüm iş yeri bilgilerini boş olarak set  et
                memberInfo['kendiIsyeri'] = false;
                memberInfo['mesulMudur'] = false;
                memberInfo['kamuPersoneli'] = false;
                memberInfo['eczaci'] = false;
                memberInfo['temsilci'] = false;
                memberInfo['unemployed'] = true;
                memberInfo['muesseseSahibi'] = null;
                memberInfo['muesseseAdi'] = null;
                memberInfo['isTel'] = null;
                memberInfo['vergiDairesiAd'] = null;
                memberInfo['vergiNo'] = null;
                memberInfo['ruhsatNo'] = null;
                memberInfo['ruhsatTarihi'] = "";
                addressList[1]['citysubdivisionId'] = null;
                addressList[1]['cityId'] = null;
                addressList[1]['addressString'] = null;
                addressList[1]['semt'] = null;
            }
            console.log(memberInfo, addressList);
        }
        this.setState({memberInfo, permanentAdrsCities, permanentAdrsCitySubdivisions});
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    async validateEmailField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let recordId = this.props.selectedMember ? this.props.selectedMember.user_id : null;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        let emailAvailabilityError = this.state.emailAvailabilityError;
        error = Object.assign(error, {[id]: result});
        //console.log("error",error);
        if (recordId !== null) {
            await checkEmailAvailabilityNotIn(value, recordId)
                .then(response => {
                    if (response.data.available) {
                        //              console.log("true");
                        error = Object.assign(error, {[id]: {valid: true, message: ''}});
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: true,
                                message: ''
                            }
                        });
                        this.setState({error, emailAvailabilityError});
                    } else {
                        //console.log("false");
                        error = Object.assign(error, {[id]: {valid: false, message: 'e-posta kullanımdadır!'}});
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: false,
                                message: 'e-posta kullanımdadır!'
                            }
                        });
                        this.setState({error, emailAvailabilityError});
                    }
                }).catch(() => {
                    error = Object.assign(error, {[id]: {valid: true, message: ''}});
                    emailAvailabilityError = Object.assign(emailAvailabilityError, {[id]: {valid: true, message: ''}});
                    this.setState({error, emailAvailabilityError});
                });
        } else {
            await checkEmailAvailability(value)
                .then(response => {
                    if (response.data.available) {
                        //console.log("true");
                        error = Object.assign(error, {[id]: {valid: true, message: ''}});
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: true,
                                message: ''
                            }
                        });
                        this.setState({error, emailAvailabilityError});
                    } else {
                        // console.log("false");
                        error = Object.assign(error, {[id]: {valid: false, message: 'e-posta kullanımdadır!'}});
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: false,
                                message: 'e-posta kullanımdadır!'
                            }
                        });
                        this.setState({error, emailAvailabilityError});
                    }
                }).catch(() => {
                    error = Object.assign(error, {[id]: {valid: true, message: ''}});
                    emailAvailabilityError = Object.assign(emailAvailabilityError, {[id]: {valid: true, message: ''}});
                    this.setState({error, emailAvailabilityError});
                });

        }
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateEmailClass(id) {
        let error = this.state.emailAvailabilityError;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChangeMember(name, value) {

        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;
        this.setState({memberInfo});
    }

    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;
        this.setState({memberInfo});
    }

    onChangeMemberUpperCase(name, value) {
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value.toString().toLocaleUpperCase();
        this.setState({memberInfo});
    }

    onChangeMemberLowerCase(name, value) {
        let memberInfo = this.state.memberInfo;
        if (name === 'username') {
            value = value.toString().replace('@', '');
        }
        memberInfo[name] = value.toString().toLocaleLowerCase();
        this.setState({memberInfo});
    }

    onChangeCheckBox(name, value) {
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;

        if (name === 'kendiIsyeri' && value) {
            memberInfo['muesseseSahibi'] = memberInfo['ad'] + ' ' + memberInfo['soyad'];
            memberInfo['mesulMudur'] = true;
            memberInfo['calismaBelgeli'] = false;

        } else if (name === 'calismaBelgeli' && value) {
            memberInfo['mesulMudur'] = false;
            memberInfo['kendiIsyeri'] = false;

        } else if (name === 'mesulMudur' && value) {
            memberInfo['calismaBelgeli'] = false;
        }

        if (memberInfo['kendiIsyeri']) //işyeri sahibiyse mesul müdür true olsun.
        {
            memberInfo['mesulMudur'] = true;
        }

        if (memberInfo['calismaBelgeli'] === false) {
            memberInfo['calismaBelgesiPath'] = null;
            memberInfo['calismaBelgesiFile'] = null;
            memberInfo['calismaBelgesiThumbFile'] = null;
        }

        this.setState({memberInfo});
    }


    onChangeAddress(name, value, index, type) {
        console.log("name,value,index,type", name, value, index, type);
        let addressInfo = this.state.memberInfo.addressList;
        if (type === 'string') {
            addressInfo[index][name] = value.toString().toLocaleUpperCase();
        } else {//select
            if (value === null) {
                addressInfo[index][name] = null;
            } else {
                addressInfo[index][name] = value.value;
            }

            if (name === 'cityId') {
                if (index === 0) {
                    (value !== null) ? this.setState({permanentAdrsCitySubdivisions: getCitySubdivisions(value.value, this.props.citySubdivisions)}) : this.setState({permanentAdrsCitySubdivisions: null});
                } else if (index === 1) {
                    (value !== null) ? this.setState({workAdrsCitySubdivisions: getCitySubdivisions(value.value, this.props.citySubdivisions)}) : this.setState({workAdrsCitySubdivisions: null});
                }
                addressInfo[index]['citysubdivisionId'] = null;
            }
        }

        this.setState({addressInfo});
    }

    onCityInfoChange(name, value) {
        let cityInfo = this.state.memberInfo.city;
        if (value === null) {
            cityInfo[name] = null;
        } else {
            cityInfo[name] = value.value;
        }
        this.setState({cityInfo});

    }

    onSelectChange(name, value) {
        let memberInfo = this.state.memberInfo;
        if (value === null) {
            memberInfo[name] = null
        } else {
            memberInfo[name] = value.value;
        }
        this.setState({memberInfo});
    }

    saveMember(action) {
        let self = this;
        let params;
        let data;
        let message;
        let validity = this.validateComponent();
//        let emailAvailable=this.state.emailAvailabilityError['tEmail']=== undefined ? true : (this.state.emailAvailabilityError['tEmail'].valid ? true : false);
        let validity_ = this.validateMemberInfo();
        if (validity.valid && validity_ === '') {
            self.setState({isLoading: true});
            let member = deepCopyObject(this.state.memberInfo);
            member = trimObject(member);

            if (action === "ONAYLA" || action === "KAYDET") {
                member.basvuruDurumu = "ONAYLANDI";
            } else if (action === "IADE") {
                member.basvuruDurumu = "UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR";
            } else if (action === "RED") {
                member.basvuruDurumu = "REDDEDILDI";
            }
            data = member;
            if (member.id === null) {
                message = 'Uye Bilgileri Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/uye/create-by-admin/",
                    data: data,
                    method: 'post'
                };
            } else {
                if (action === "ONAYLA" || action === "RED" || action === "IADE") {
                    message = 'Uye Durumu Başarıyla Güncellendi.'
                    params = {
                        url: API_BASE_URL + "/uye/updateStatus/" + member.id + "/" + member.basvuruDurumu,
                        data: data,
                        method: 'put'
                    };

                } else {
                    message = 'Uye Bilgileri Başarıyla Güncellendi.'
                    params = {
                        url: API_BASE_URL + "/uye/update-by-admin/",
                        data: data,
                        method: 'put'
                    };
                }
            }

            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading: false});
                this.cancelProcess();
                self.props.handleSearch(self.props.searchQuery, true);
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        } else {
            validity_ = 'Hatalı Alanlar var! </br>' + validity_;
            Alert.error(
                validity_, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }
    }

    validateMemberInfo() {
        let memberInfo = this.state.memberInfo;
        let errorMessage = '';
        if (memberInfo.username === null || memberInfo.username.toString().trim() === '') {
            errorMessage += 'Kullanıcı Adı Giriniz!</br>';
        }

        if (memberInfo.username !== null && memberInfo.username.toString().trim().length < 6) {
            errorMessage += 'Kullanıcı Adı En Az 6 Hane Uzunluğunda Olmalıdır!</br>';
        }

        if (memberInfo.odaKayitTarihi === null || memberInfo.odaKayitTarihi === '') {
            errorMessage += 'Oda Kayıt  Tarihi Boş Olamaz!</br>';
        }


        if (memberInfo.email === null || memberInfo.email.toString().trim() === '') {
            errorMessage += 'E-posta Adresi Giriniz!</br>';
        }


        if (memberInfo.ad === null || memberInfo.ad.toString().trim() === '') {
            errorMessage += 'Ad Boş Olamaz!</br>';
        }

        if (memberInfo.soyad === null || memberInfo.soyad.toString().trim() === '') {
            errorMessage += 'Soyad Boş Olamaz!</br>';
        }

        if (memberInfo.tcKimlikNo === null) {
            errorMessage += 'TC Kimlik No Boş Olamaz!</br>';
        }

        if (memberInfo.tcKimlikNo.toString().trim().length !== 11) {
            errorMessage += 'TC Kimlik No Alanı 11 Hane Uzunluğunda Olmalıdır!</br>';
        }

        if (memberInfo.kimlikTipi === null) {
            errorMessage += 'Kimlik Tipi Seçiniz!</br>';
        }

        if (memberInfo.kimlikTipi === "TCKimlikKarti") {
            if (memberInfo.kimlikSonGecerlilikTarihi === null) {
                errorMessage += 'Kimlik Son Geçerlilik Tarihi Seçiniz!</br>';
            }
        } else if (memberInfo.kimlikTipi === "NufusCuzdani") {
            if (memberInfo.kayitNo === null || memberInfo.kayitNo.toString().trim() === '') {
                errorMessage += 'Kimlik Kayıt No Giriniz!</br>';
            }
        }

        if (memberInfo.anaAdi === null || memberInfo.anaAdi.toString().trim() === '') {
            errorMessage += 'Ana Adı Boş Olamaz!</br>';
        }

        if (memberInfo.babaAdi === null || memberInfo.babaAdi.toString().trim() === '') {
            errorMessage += 'Baba Adı Boş Olamaz!</br>';
        }

        if (memberInfo.cuzdanKimlikSeriNo === null || memberInfo.cuzdanKimlikSeriNo.toString().trim() === '') {
            errorMessage += 'Nüfus Cüzdanı/TC Kimlik Seri No Boş Olamaz!</br>';
        }


        if (memberInfo.dogumYeri === null || memberInfo.dogumYeri.toString().trim() === '') {
            errorMessage += 'Doğum Yeri Boş Olamaz!</br>';
        }


        if (memberInfo.dogumTarihi === null || memberInfo.dogumTarihi === '') {
            errorMessage += 'Dogum Tarihi Boş Olamaz!</br>';
        }


        if (memberInfo.medeniHali === null || memberInfo.medeniHali === '') {
            errorMessage += 'Medeni Hali Boş Olamaz!</br>';
        }

        if (memberInfo.city.id === null || memberInfo.city.id === '') {
            errorMessage += 'Oda İli Boş Olamaz!</br>';
        }
        /*if(memberInfo.citySubDivisionId===null || memberInfo.citySubDivisionId==='')
        {
            errorMessage += 'Oda İlçe Boş Olamaz!</br>'  ;
        }*/

        /* if(memberInfo.ikametAdres===null || memberInfo.ikametAdres.toString().trim()==='')
         {
             errorMessage += 'İkamet Adresi Boş Olamaz!</br>'  ;
         }*/

        if (memberInfo.gsmTel === null || memberInfo.gsmTel.toString().trim() === '') {
            errorMessage += 'GSM Tel Boş Olamaz!</br>';
        }
        if (memberInfo.cinsiyet === null) {
            errorMessage += 'Cinsiyet Seçiniz!</br>';
        }
        if (memberInfo.belgeTuru === null) {
            errorMessage += 'Mezuniyet Belge Türü Seçiniz!</br>';
        }
        /*  if(memberInfo.odaSicilNo===null || memberInfo.odaSicilNo.toString().trim()==='' || memberInfo.odaSicilNo.toString().trim().length!==9 )
          {
              errorMessage += 'Oda Sicilno 9 hane uzunluğunda olmalıdır!</br>'  ;
          }
          //

           if(memberInfo.universite===null || memberInfo.universite.toString().trim()==='')
           {
               errorMessage += 'Üniversite Bilgisi Boş Olamaz!</br>'  ;
           }


           if(memberInfo.mezuniyetTarihi===null || memberInfo.mezuniyetTarihi==='')
           {
               errorMessage += 'Mezuniyet Tarihi Boş Olamaz!</br>'  ;
           }

           if(memberInfo.diplomaNo===null || memberInfo.diplomaNo.toString().trim()==='')
           {
               errorMessage += 'Diploma No Boş Olamaz!</br>'  ;
           }*/

        /*  if(memberInfo.fotoFile===null || memberInfo.fotoFile==='')
          {
              errorMessage += 'Fotoğraf Yükleyiniz!</br>'  ;
          }
          if(memberInfo.kimlikCuzdanFile===null || memberInfo.kimlikCuzdanFile==='')
          {
              errorMessage += 'Kimlik Resmi Yükleyiniz!</br>'  ;
          }*/
        /*if(memberInfo.diplomaFile===null || memberInfo.diplomaFile==='')
        {
            errorMessage += 'Diploma Resmi Yükleyiniz!</br>'  ;
        }*/
        /* if(memberInfo.adliSicilFile===null || memberInfo.adliSicilFile==='')
         {
             errorMessage += 'Adli Sicil Belgesi Resmi Yükleyiniz!</br>'  ;
         }

         if(memberInfo.ikametgahFile===null || memberInfo.ikametgahFile==='')
         {
             errorMessage += 'İkametgah Belgesi Resmi Yükleyiniz!</br>'  ;
         }
 */
        if (!memberInfo.uyelikAktif) {
            if (memberInfo.uyelikPasiflikNedeni === null || memberInfo.uyelikPasiflikNedeni.toString().trim() === '')
                errorMessage += 'İlişik Kesme Sebebi Giriniz!</br>';
        }

        if (!memberInfo.uyeCalisiyor) {
            if (memberInfo.uyelikDurdurmaDilekcePath === null || memberInfo.uyelikDurdurmaDilekcePath.toString() === '')
                errorMessage += 'Pasife Alma Dilekçesi Yükleyiniz!</br>';
        }

        return errorMessage;
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }


    render() {

        const cinsiyetOptions = [
            {label: 'BELİRTİLMEMİŞ', value: 'BELIRTILMEMIS'},
            {label: 'ERKEK', value: 'ERKEK'},
            {label: 'KADIN', value: 'KADIN'},
        ]

        const medeniHalOptions = [
            {label: 'BEKAR', value: 'BEKAR'},
            {label: 'EVLI', value: 'EVLI'},
            {label: 'DUL', value: 'DUL'}
        ]

        const KimlikTipiOptions = [
            {label: 'Nüfus Cüzdanı', value: 'NufusCuzdani'},
            {label: 'TC Kimlik Kartı', value: 'TCKimlikKarti'}
        ]

        const BelgeTipiOptions = [
            {label: 'DİPLOMA', value: 'DIPLOMA'},
            {label: 'GÖZLÜKÇÜLÜK RUHSATNAMESİ', value: 'RUHSATNAME'},
            {label: 'GEÇİCİ MEZUNİYET BELGESİ', value: 'GECICI_MEZUNIYET'}
        ]

        let tDogumTarihi = this.state.memberInfo.dogumTarihi ? {value: moment.utc(this.state.memberInfo.dogumTarihi, "YYYY-MM-DD")} : {};
        let tKimlikSonGecerlilikTarihi = this.state.memberInfo.kimlikSonGecerlilikTarihi ? {value: moment.utc(this.state.memberInfo.kimlikSonGecerlilikTarihi, "YYYY-MM-DD")} : {};
        let tMezuniyetTarihi = this.state.memberInfo.mezuniyetTarihi ? {value: moment.utc(this.state.memberInfo.mezuniyetTarihi, "YYYY-MM-DD")} : {};
        let tGozRuhTarih = this.state.memberInfo.gozRuhTarih ? {value: moment.utc(this.state.memberInfo.gozRuhTarih, "YYYY-MM-DD")} : {};
        let tRuhsatTarihi = this.state.memberInfo.ruhsatTarihi ? {value: moment.utc(this.state.memberInfo.ruhsatTarihi, "YYYY-MM-DD")} : {};
        let tOdaKayitTarihi = this.state.memberInfo.odaKayitTarihi ? {value: this.state.memberInfo.odaKayitTarihi} : {};

        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Oda/Portal Giriş Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Oda İl: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCity')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.citySelectionDisabled}
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="city"
                                        id="tCity"
                                        ref="tCity"
                                        onBlur={this.validateField}
                                        style={{width: 160, minWidth: 160}}
                                        inputProps={{'vdata': "required"}}
                                        options={this.state.workAdrsCities}
                                        onChange={(value) => this.onCityInfoChange("id", value)}
                                        value={this.state.memberInfo.city.id}/>
                                    {this.validateMessage('tCity') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tCity" delay={0}>
                                        {this.validateMessage("tCity")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            {(this.state.memberInfo.id !== null) &&
                            <div className='row'>
                                <label className="col-sm-3">SicilNo: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tOdaSicilNo')}>
                                    <input className="form-control"
                                           disabled={true}
                                           type="text"
                                           name="odaSicilNo"
                                           id="tOdaSicilNo"
                                           maxLength="9"
                                           data-vlength="9"
                                        // inputProps={{'vdata': "required", 'vlength': "9"}}
                                        // onBlur={this.validateField}
                                        // ref="tOdaSicilNo"
                                           value={this.state.memberInfo.odaSicilNo}
                                        //onChange={(e) => this.onChangeMember("odaSicilNo", e.target.value)}
                                    />
                                    {this.validateMessage('tOdaSicilNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tOdaSicilNo" delay={0}>
                                        {this.validateMessage("tOdaSicilNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            }
                            <div className='row'>
                                <label className="col-sm-3">Kullanıcı Adı: *</label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tUsername')}>
                                    <input className="form-control uppercase"
                                           disabled={this.state.fieldsDisabled}
                                           type="text"
                                           name="username"
                                           id="tUsername"
                                           maxLength="50"
                                           data-vlength="6,50"
                                           onBlur={this.validateField}
                                           ref="tUsername"
                                           value={this.state.memberInfo.username || ""}
                                           onChange={(e) => this.onChangeMemberLowerCase("username", e.target.value)}
                                    />
                                    {this.validateMessage('tUsername') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tUsername" delay={0}>
                                        {this.validateMessage("tUsername")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">E-posta *</label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tEmail')}>
                                    <Maskedinput className="form-control"
                                                 disabled={this.state.fieldsDisabled}
                                                 type="text"
                                                 mask={emailMask}
                                                 name="email"
                                                 inputProps={{vdata: "email", vlength: '1,255'}}
                                                 id="tEmail"
                                                 onBlur={() => this.validateField({
                                                     target: {
                                                         id: "tEmail",
                                                         dataset: {vdata: "email", vlength: '1,255'},
                                                         value: this.state.memberInfo.email
                                                     }
                                                 })}
                                                 placeholder="_________@______.___"
                                                 ref="tEmail"
                                                 value={this.state.memberInfo.email}
                                                 onChange={(e) => this.onChangeMemberLowerCase("email", e.target.value)}
                                    />
                                    {this.validateMessage('tEmail') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tEmail" delay={0}>
                                        {this.validateMessage("tEmail")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Kayıt Tarihi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tOdaKayitTarihi')}>
                                    <DatePicker {...tOdaKayitTarihi}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="odaKayitTarihi"
                                                id="tOdaKayitTarihi"
                                                ref="tOdaKayitTarihi"
                                                style={{width: 160}}
                                                inputProps={{'vdata': "required"}}
                                                onChange={(date) => this.onChangeMember("odaKayitTarihi", date)}/>
                                    {this.validateMessage('tOdaKayitTarihi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tOdaKayitTarihi" delay={0}>
                                        {this.validateMessage("tOdaKayitTarihi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Mezuniyet Belge Tipi:*</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tBelgeTuru')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        defaultValue={{label: 'DİPLOMA', value: 'DIPLOMA'}}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="belgeTuru"
                                        id="tBelgeTuru"
                                        ref="tBelgeTuru"
                                        style={{flex: 1}}
                                        inputProps={{'vdata': "required"}}
                                        options={BelgeTipiOptions}
                                        onChange={(value) => this.onSelectChange("belgeTuru", value)}

                                        value={this.state.memberInfo.belgeTuru}/>
                                    {this.validateMessage('tBelgeTuru') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tBelgeTuru" delay={0}>
                                        {this.validateMessage("tBelgeTuru")}
                                    </UncontrolledTooltip>}

                                </div>
                            </div>

                            {
                                (this.state.memberInfo.belgeTuru === 'DIPLOMA') &&
                                <div>
                                    <div className="row">
                                        <Label className="col-sm-3">Üniversite:</Label>
                                        <div className={"col-sm-8 form-group" + this.validateClass('tUniversite')}>
                                            <input className="form-control"
                                                   type="text"
                                                   disabled={this.state.fieldsDisabled}
                                                   name="universite"
                                                   id="tUniversite"
                                                   maxLength="50"
                                                   value={this.state.memberInfo.universite || ""}
                                                   onChange={(e) => this.onChangeMemberUpperCase("universite", e.target.value)}/>
                                            {this.validateMessage('tUniversite') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tUniversite" delay={0}>
                                                {this.validateMessage("tUniversite")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <Label className="col-sm-3">Diploma No/Mezuniyet Tarihi:</Label>
                                        <div className={"col-sm-4 form-group" + this.validateClass('tDiplomaNo')}>
                                            <input className="form-control"
                                                   type="text"
                                                   disabled={this.state.fieldsDisabled}
                                                   name="diplomaNo"
                                                   id="tDiplomaNo"
                                                   maxLength="50"
                                                   style={{flex: 1}}
                                                   value={this.state.memberInfo.diplomaNo || ""}
                                                   onChange={(e) => this.onChangeMemberUpperCase("diplomaNo", e.target.value)}/>
                                            {this.validateMessage('tDiplomaNo') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tDiplomaNo" delay={0}>
                                                {this.validateMessage("tDiplomaNo")}
                                            </UncontrolledTooltip>}
                                        </div>
                                        <div className={"col-sm-4 form-group" + this.validateClass('tMezuniyetTarihi')}>
                                            <DatePicker {...tMezuniyetTarihi}
                                                        className="basic-single"
                                                        placeholder="Tarih seçiniz."
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        format="DD.MM.YYYY"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        style={{flex: 1}}
                                                        name="mezuniyetTarihi"
                                                        onChange={(date, dateString) => this.onChangeDateString("mezuniyetTarihi", dateString)}/>
                                            {this.validateMessage('tMezuniyetTarihi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tMezuniyetTarihi" delay={0}>
                                                {this.validateMessage("tMezuniyetTarihi")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.memberInfo.belgeTuru === 'RUHSATNAME') &&

                                <div>
                                    <div className="row">
                                        <Label className="col-sm-3">G. Ruhsatnamesini Veren Kurum:</Label>
                                        <div className={"col-sm-8 form-group" + this.validateClass('tGozRuhKurum')}>
                                            <input className="form-control"
                                                   type="text"
                                                   disabled={this.state.fieldsDisabled}
                                                   name="gozRuhKurum"
                                                   id="tGozRuhKurum"
                                                   maxLength="50"
                                                   style={{flex: 1}}
                                                   value={this.state.memberInfo.gozRuhKurum || ""}
                                                   onChange={(e) => this.onChangeMemberUpperCase("gozRuhKurum", e.target.value)}/>
                                            {this.validateMessage('tGozRuhKurum') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tGozRuhKurum" delay={0}>
                                                {this.validateMessage("tGozRuhKurum")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <Label className="col-sm-3">G.Ruhsatname Cilt-Yaprak No/Tarih:</Label>
                                        <div className={"col-sm-4 form-group" + this.validateClass('tGozRuhNo')}>
                                            <input className="form-control"
                                                   type="text"
                                                   disabled={this.state.fieldsDisabled}
                                                   name="gozRuhNo"
                                                   id="tGozRuhNo"
                                                   maxLength="50"
                                                   style={{flex: 1}}
                                                   value={this.state.memberInfo.gozRuhNo || ""}
                                                   onChange={(e) => this.onChangeMemberUpperCase("gozRuhNo", e.target.value)}/>
                                            {this.validateMessage('tGozRuhNo') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tGozRuhNo" delay={0}>
                                                {this.validateMessage("tGozRuhNo")}
                                            </UncontrolledTooltip>}
                                        </div>
                                        <div className={"col-sm-4 form-group" + this.validateClass('tGozRuhTarih')}>
                                            <DatePicker {...tGozRuhTarih}
                                                        className="basic-single"
                                                        placeholder="Tarih seçiniz."
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        format="DD.MM.YYYY"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        style={{flex: 1}}
                                                        name="gozRuhTarih"
                                                        onChange={(date, dateString) => this.onChangeDateString("gozRuhTarih", dateString)}/>
                                            {this.validateMessage('tGozRuhTarih') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tGozRuhTarih" delay={0}>
                                                {this.validateMessage("tGozRuhTarih")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.memberInfo.belgeTuru === 'GECICI_MEZUNIYET') &&
                                <div className="row">
                                    <Label className="col-sm-3">Mezun Olacağınız Tarih:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tMezuniyetTarihi')}>
                                        <DatePicker {...tMezuniyetTarihi}
                                                    className="basic-single"
                                                    placeholder="Tarih seçiniz."
                                                    disabled={this.state.fieldsDisabled}
                                                    classNamePrefix="select"
                                                    format="DD.MM.YYYY"
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    style={{flex: 1}}
                                                    name="mezuniyetTarihi"
                                                    onChange={(date, dateString) => this.onChangeDateString("mezuniyetTarihi", dateString)}/>
                                        {this.validateMessage('tMezuniyetTarihi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tMezuniyetTarihi" delay={0}>
                                            {this.validateMessage("tMezuniyetTarihi")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            }
                        </div>


                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Üye Durumu</span>
                            <div>
                                {this.props.currentUser.realm === 0 &&
                                    <div className="row">
                                    <Label className="col-sm-3">Üyelik Dondur:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tUyeCalisiyor')}>
                                        <Switch checked={this.state.memberInfo.uyeCalisiyor}
                                                disabled={this.state.fieldsDisabled}
                                                checkedChildren="Hayır"
                                                unCheckedChildren="Evet"
                                                style={{width: 150}}
                                                onChange={(e) => this.onChangeCheck("uyeCalisiyor", e)}
                                        />
                                    </div>
                                </div>}
                                <div className="row">
                                    <Label className="col-sm-3">İşsiz mi?:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tUnemployed')}>
                                        <Switch checked={this.state.memberInfo.unemployed}
                                                disabled={this.state.fieldsDisabled}
                                                checkedChildren="Evet"
                                                unCheckedChildren="Hayır"
                                                style={{width: 150}}
                                                onChange={(e) => this.onChangeUnemployedCheck("unemployed", e)}
                                        />
                                    </div>
                                </div>
                                {<div className="row">
                                    <Label className="col-sm-3">Oda İlişiği:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tUyelikAktif')}>
                                        <Switch checked={this.state.memberInfo.uyelikAktif}
                                                disabled={this.state.isPreviouslyInactivated || this.state.fieldsDisabled}
                                                checkedChildren="Aktif(Devam Ediyor)"
                                                unCheckedChildren="Pasif(İlişik Kesildi)"
                                                style={{width: 150}}
                                                onChange={(e) => {
                                                    this.state.memberInfo.uyelikAktif
                                                        ?
                                                        this.setState({inActivateMemberModal: true})
                                                        :
                                                        this.onChangeCheck("uyelikAktif", e)
                                                }}
                                        />
                                    </div>
                                </div>}
                                <div className="row">
                                    <Label className="col-sm-3">Taahhütlü mü ?:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('tTaahhut')}>
                                        <Switch checked={this.state.memberInfo.taahhut}
                                                disabled={this.state.fieldsDisabled}
                                                checkedChildren="Evet"
                                                unCheckedChildren="Hayır"
                                                style={{width: 150}}
                                                onChange={(e) => this.onChangeCheck("taahhut", e)}
                                        />
                                    </div>
                                </div>
                                {
                                    (!this.state.memberInfo.uyelikAktif) &&
                                    <div className="row">
                                        <Label className="col-sm-3">İlişik Kesme Nedeni: *</Label>
                                        <div
                                            className={"col-sm-8 form-group" + this.validateClass('tUyelikPasiflikNedeni')}>
                                            <TextArea className="form-control"
                                                      type="text"
                                                      name="uyelikPasiflikNedeni"
                                                      id="tUyelikPasiflikNedeni"
                                                      maxLength="255"
                                                      disabled={this.state.isPreviouslyInactivated || this.state.fieldsDisabled}
                                                      value={this.state.memberInfo.uyelikPasiflikNedeni}
                                                      onChange={(e) => this.onChangeMemberUpperCase("uyelikPasiflikNedeni", e.target.value)}/>
                                            {this.validateMessage('tUyelikPasiflikNedeni') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tUyelikPasiflikNedeni"
                                                                 delay={0}>
                                                {this.validateMessage("tUyelikPasiflikNedeni")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>

                                }
                                {(this.state.memberInfo.taahhut) &&
                                <div className="row">
                                    <Label className="col-sm-3">Taahhüt Belgesi: *</Label>
                                    <div className="col-sm-8 form-group">
                                        <Uploader2 onInfoChange={this.onChangeMember}
                                                   fileName="taahhutBelgesiFile"
                                                   thumbFileName="taahhutBelgesiThumbFile"
                                                   filePathName="taahhutBelgesiPath"
                                                   pathPrefix="taahhutbelgesi"
                                                   memberTCKN={this.state.memberInfo.tcKimlikNo}
                                                   filePath={this.state.memberInfo.taahhutBelgesiPath}
                                                   file={this.state.memberInfo.taahhutBelgesiFile}
                                                   thumb={this.state.memberInfo.taahhutBelgesiThumbFile}
                                                   isDisabled={this.state.fieldsDisabled}/>
                                    </div>
                                </div>}
                                {this.props.currentUser.realm === 0 && (!this.state.memberInfo.uyeCalisiyor) &&
                                <div className="row">
                                    <Label className="col-sm-3">Pasife Alma Dilekçesi: *</Label>
                                    <div className="col-sm-8 form-group">
                                        <Uploader2 onInfoChange={this.onChangeMember}
                                                   fileName="uyelikDurdurmaDilekceFile"
                                                   thumbFileName="uyelikDurdurmaDilekceThumbFile"
                                                   filePathName="uyelikDurdurmaDilekcePath"
                                                   pathPrefix="durdurma"
                                                   memberTCKN={this.state.memberInfo.tcKimlikNo}
                                                   filePath={this.state.memberInfo.uyelikDurdurmaDilekcePath}
                                                   file={this.state.memberInfo.uyelikDurdurmaDilekceFile}
                                                   thumb={this.state.memberInfo.uyelikDurdurmaDilekceThumbFile}
                                                   isDisabled={this.state.fieldsDisabled}/>
                                    </div>
                                </div>}
                            </div>
                        </div>

                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Kimlik Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Ad: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tAd')}>
                                    <input className="form-control"
                                           disabled={this.state.fieldsDisabled}
                                           type="text"
                                           name="ad"
                                           id="tAd"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tAd"
                                           value={this.state.memberInfo.ad || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("ad", e.target.value)}/>
                                    {this.validateMessage('tAd') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tAd" delay={0}>
                                        {this.validateMessage("tAd")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Soyad */Eski Soyad:</Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tSoyad')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="soyad"
                                           id="tSoyad"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tSoyad"
                                           value={this.state.memberInfo.soyad || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("soyad", e.target.value)}/>
                                    {this.validateMessage('tSoyad') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tSoyad" delay={0}>
                                        {this.validateMessage("tSoyad")}
                                    </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tEskiSoyad')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="eskiSoyad"
                                           id="tEskiSoyad"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           value={this.state.memberInfo.eskiSoyad || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("eskiSoyad", e.target.value)}/>
                                    {this.validateMessage('tEskiSoyad') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tEskiSoyad" delay={0}>
                                        {this.validateMessage("tEskiSoyad")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">TC Kimlik No: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tTckNo')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="tckNo"
                                           id="tTckNo"
                                           maxLength="11"
                                        //inputProps={{vdata: "identifier", vlength: '11'}}
                                           data-vlength="11"
                                           onBlur={() => this.validateField({
                                               target: {
                                                   id: "tTckNo",
                                                   dataset: {vdata: "identifier", vlength: '11'},
                                                   value: this.state.memberInfo.tcKimlikNo
                                               }
                                           })}
                                           ref="tTckNo"
                                           value={this.state.memberInfo.tcKimlikNo || ""}
                                           onChange={(e) => this.onChangeMember("tcKimlikNo", e.target.value)}/>
                                    {this.validateMessage('tTckNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tTckNo" delay={0}>
                                        {this.validateMessage("tTckNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Doğum Tarihi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tDogumTarihi')}>
                                    <DatePicker {...tDogumTarihi}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="dogumTarihi"
                                                id="tDogumTarihi"
                                                ref="tDogumTarihi"
                                                style={{width: 160}}
                                                inputProps={{'vdata': "required"}}
                                                onChange={(date, dateString) => this.onChangeDateString("dogumTarihi", dateString)}/>
                                    {this.validateMessage('tDogumTarihi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tDogumTarihi" delay={0}>
                                        {this.validateMessage("tDogumTarihi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Cinsiyet: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCinsiyet')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="cinsiyet"
                                        id="tCinsiyet"
                                        ref="tCinsiyet"
                                        style={{width: 160, minWidth: 160}}
                                        inputProps={{'vdata': "required"}}
                                        options={cinsiyetOptions}
                                        onChange={(value) => this.onSelectChange("cinsiyet", value)}
                                        value={this.state.memberInfo.cinsiyet}/>
                                    {this.validateMessage('tCinsiyet') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tCinsiyet" delay={0}>
                                        {this.validateMessage("tCinsiyet")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Baba Adı: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tBabaAdi')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="babaAdi"
                                           id="tBabaAdi"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tBabaAdi"
                                           value={this.state.memberInfo.babaAdi || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("babaAdi", e.target.value)}/>
                                    {this.validateMessage('tBabaAdi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tBabaAdi" delay={0}>
                                        {this.validateMessage("tBabaAdi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Ana Adı: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tAnaAdi')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="anaAdi"
                                           id="tAnaAdi"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tAnaAdi"
                                           value={this.state.memberInfo.anaAdi || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("anaAdi", e.target.value)}/>
                                    {this.validateMessage('tAnaAdi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tAnaAdi" delay={0}>
                                        {this.validateMessage("tAnaAdi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Kimlik Tipi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKimlikTipi')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="kimlikTipi"
                                        id="tKimlikTipi"
                                        ref="tKimlikTipi"
                                        style={{width: 160, minWidth: 160}}
                                        inputProps={{'vdata': "required"}}
                                        options={KimlikTipiOptions}
                                        onChange={(value) => this.onSelectChange("kimlikTipi", value)}

                                        value={this.state.memberInfo.kimlikTipi}/>
                                    {this.validateMessage('tKimlikTipi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tKimlikTipi" delay={0}>
                                        {this.validateMessage("tKimlikTipi")}
                                    </UncontrolledTooltip>}

                                </div>
                            </div>


                            <div className="row">
                                <Label className="col-sm-3">N.Cüzdanı/TC Kimlik Seri No: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCuzdanKimlikSeriNo')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="cuzdanKimlikSeriNo"
                                           id="tCuzdanKimlikSeriNo"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tCuzdanKimlikSeriNo"
                                           value={this.state.memberInfo.cuzdanKimlikSeriNo || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("cuzdanKimlikSeriNo", e.target.value)}/>
                                    {this.validateMessage('tCuzdanKimlikSeriNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tCuzdanKimlikSeriNo" delay={0}>
                                        {this.validateMessage("tCuzdanKimlikSeriNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            {
                                (this.state.memberInfo.kimlikTipi === "NufusCuzdani")
                                    ?
                                    <div className="row">
                                        <Label className="col-sm-3">Kimlik Kayıt No:</Label>
                                        <div className={"col-sm-8 form-group" + this.validateClass('tKayitNo')}>
                                            <input className="form-control"
                                                   type="text"
                                                   disabled={this.state.fieldsDisabled}
                                                   name="KayitNo"
                                                   id="tKayitNo"
                                                   maxLength="50"
                                                   data-vlength="1,50"
                                                   onBlur={this.validateField}
                                                   ref="tKayitNo"
                                                   value={this.state.memberInfo.kayitNo || ""}
                                                   onChange={(e) => this.onChangeMemberUpperCase("kayitNo", e.target.value)}/>
                                            {this.validateMessage('tKayitNo') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tKayitNo" delay={0}>
                                                {this.validateMessage("tKayitNo")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    :
                                    ""
                            }

                            {
                                (this.state.memberInfo.kimlikTipi === "TCKimlikKarti")
                                    ?
                                    <div className="row">
                                        <Label className="col-sm-3">Kimlik Son Geçerlilik Tarihi:</Label>
                                        <div
                                            className={"col-sm-8 form-group" + this.validateClass('tKimlikSonGecerlilikTarihi')}>
                                            <DatePicker {...tKimlikSonGecerlilikTarihi}
                                                        className="basic-single"
                                                        placeholder="Tarih seçiniz."
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        format="DD.MM.YYYY"
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        name="kimlikSonGecerlilikTarihi"
                                                        id="tKimlikSonGecerlilikTarihi"
                                                        ref="tKimlikSonGecerlilikTarihi"
                                                        style={{width: 160}}
                                                        inputProps={{'vdata': "required"}}
                                                        onChange={(date, dateString) => this.onChangeDateString("kimlikSonGecerlilikTarihi", dateString)}/>
                                            {this.validateMessage('tKimlikSonGecerlilikTarihi') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tKimlikSonGecerlilikTarihi"
                                                                 delay={0}>
                                                {this.validateMessage("tKimlikSonGecerlilikTarihi")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                    :
                                    ""
                            }
                            <div className="row">
                                <Label className="col-sm-3">Doğum Yeri: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tDogumYeri')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="dogumYeri"
                                           id="tDogumYeri"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tDogumYeri"
                                           value={this.state.memberInfo.dogumYeri || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("dogumYeri", e.target.value)}/>
                                    {this.validateMessage('tDogumYeri') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tDogumYeri" delay={0}>
                                        {this.validateMessage("tDogumYeri")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Medeni Hali: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tMedeniHali')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="medeniHal"
                                        id="tMedeniHali"
                                        ref="tMedeniHali"
                                        style={{width: 160, minWidth: 160}}
                                        inputProps={{'vdata': "required"}}
                                        options={medeniHalOptions}
                                        onChange={(value) => this.onSelectChange("medeniHali", value)}

                                        value={this.state.memberInfo.medeniHali}/>
                                    {this.validateMessage('tMedeniHali') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tMedeniHali" delay={0}>
                                        {this.validateMessage("tMedeniHali")}
                                    </UncontrolledTooltip>}

                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Kan Grubu:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKanGrubu')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="kanGrubu"
                                           id="tKanGrubu"
                                           maxLength="7"
                                           onBlur={this.validateField}
                                           style={{width: 160, minWidth: 160}}
                                           value={this.state.memberInfo.kanGrubu || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("kanGrubu", e.target.value)}/>
                                    {this.validateMessage('tKanGrubu') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tKanGrubu" delay={0}>
                                        {this.validateMessage("tKanGrubu")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">İletişim Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">GSM Telefonu: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tGsmTel')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="gsmTel"
                                           id="tGsmTel"
                                           maxLength="10"
                                           data-vlength="10"
                                           onBlur={this.validateField}
                                           ref="tGsmTel"
                                           value={this.state.memberInfo.gsmTel || ""}
                                           onChange={(e) => this.onChangeMember("gsmTel", e.target.value)}/>
                                    {this.validateMessage('tGsmTel') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tGsmTel" delay={0}>
                                        {this.validateMessage("tGsmTel")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İkamet Adresi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tPermAdres')}>
                                    <TextArea className="form-control"
                                              type="text"
                                              disabled={this.state.fieldsDisabled}
                                              name="permAdres"
                                              id="tPermAdres"
                                              maxLength="255"
                                              style={{height: 60, minHeight: 60}}
                                              value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].addressString}
                                              onChange={(e) => this.onChangeAddress("addressString", e.target.value, 0, 'string')}/>
                                    {this.validateMessage('tPermAdres') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tPermAdres" delay={0}>
                                        {this.validateMessage("tPermAdres")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İkamet İl/İlçe: </Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tPermAdrsCity')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="permAdrsCity"
                                        id="tPermAdrsCity"
                                        style={{flex: 0.9}}
                                        /*options={this.props.cities.map(city => ({
                                            value: city.id,
                                            label: city.ad
                                        }))}*/
                                        options={this.state.permanentAdrsCities}
                                        onChange={(value) => this.onChangeAddress("cityId", value, 0, 'select')}
                                        value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].cityId}/>
                                    {this.validateMessage('tPermAdrsCity') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tPermAdrsCity" delay={0}>
                                        {this.validateMessage("tPermAdrsCity")}
                                    </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tPermAdrsCitySub')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="İlçe seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="permAdrsCitySub"
                                        id="tPermAdrsCitySub"
                                        style={{flex: 0.9}}
                                        options={this.state.permanentAdrsCitySubdivisions}
                                        onChange={(value) => this.onChangeAddress("citysubdivisionId", value, 0, 'select')}
                                        value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].citysubdivisionId}/>
                                    {this.validateMessage('tPermAdrsCitySub') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tPermAdrsCitySub" delay={0}>
                                        {this.validateMessage("tPermAdrsCitySub")}
                                    </UncontrolledTooltip>}
                                </div>

                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Semt: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tPermSemt')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="permSemt"
                                           id="tPermSemt"
                                           maxLength="20"
                                           value={this.state.memberInfo.addressList[0] && this.state.memberInfo.addressList[0].semt}
                                           onChange={(e) => this.onChangeAddress("semt", e.target.value, 0, 'string')}/>
                                    {this.validateMessage('tPermSemt') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tPermSemt" delay={0}>
                                        {this.validateMessage("tPermSemt")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Ev Telefonu:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tEvTel')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled}
                                           name="evTel"
                                           id="tEvTel"
                                           maxLength="10"
                                           value={this.state.memberInfo.evTel || ""}
                                           onChange={(e) => this.onChangeMember("evTel", e.target.value)}/>
                                    {this.validateMessage('tEvTel') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tEvTel" delay={0}>
                                        {this.validateMessage("tEvTel")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">İş Yeri Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Kendi İş Yeri mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKendiIsYeri')}>
                                    <input
                                        name="chkKendiIsYeri"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.kendiIsyeri}
                                        onChange={(e) => this.onChangeCheckBox("kendiIsyeri", e.target.checked)}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Mesul Müdür mü?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tmesulMudur')}>
                                    <input
                                        name="chkMesulMudur"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.mesulMudur}
                                        onChange={(e) => this.onChangeCheckBox("mesulMudur", e.target.checked)}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Çalışma Belgeli Personel mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tCalismaBelgeli')}>
                                    <input
                                        name="chkCalismaBelgeli"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.calismaBelgeli}
                                        onChange={(e) => this.onChangeCheckBox("calismaBelgeli", e.target.checked)}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Kamu Personeli mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tKamuPersoneli')}>
                                    <input
                                        name="chkKamuPersoneli"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.kamuPersoneli}
                                        onChange={(e) => this.onChangeCheckBox("kamuPersoneli", e.target.checked)}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Eczacı mı?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tEczaci')}>
                                    <input
                                        name="chkEczaci"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.eczaci}
                                        onChange={(e) => this.onChangeCheckBox("eczaci", e.target.checked)}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Temsilci mi?:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tTemsilci')}>
                                    <input
                                        name="chkTemsilci"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        type="checkbox"
                                        checked={this.state.memberInfo.temsilci}
                                        onChange={(e) => this.onChangeCheckBox("temsilci", e.target.checked)}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Müessese Sahibi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tMuesseseSahibi')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="muesseseSahibi"
                                           id="tMuesseseSahibi"
                                           maxLength="50"
                                           value={this.state.memberInfo.muesseseSahibi || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("muesseseSahibi", e.target.value)}/>
                                    {this.validateMessage('tMuesseseSahibi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tMuesseseSahibi" delay={0}>
                                        {this.validateMessage("tMuesseseSahibi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Müessese/Kurum Adı:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tMuesseseAdi')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="muesseseAdi"
                                           id="tMuesseseAdi"
                                           maxLength="100"
                                           value={this.state.memberInfo.muesseseAdi || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("muesseseAdi", e.target.value)}/>
                                    {this.validateMessage('tMuesseseAdi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tMuesseseAdi" delay={0}>
                                        {this.validateMessage("tMuesseseAdi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İş Yeri Telefonu:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tIsTel')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="isTel"
                                           id="tIsTel"
                                           maxLength="10"
                                           value={this.state.memberInfo.isTel || ""}
                                           onChange={(e) => this.onChangeMember("isTel", e.target.value)}/>
                                    {this.validateMessage('tIsTel') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tIsTel" delay={0}>
                                        {this.validateMessage("tIsTel")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İş Yeri Adresi: *</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tWorkAdres')}>
                                    <TextArea className="form-control"
                                              type="text"
                                              disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                              name="workAdres"
                                              id="tWorkAdres"
                                              maxLength="255"
                                              style={{height: 60, minHeight: 60}}
                                              value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].addressString}
                                              onChange={(e) => this.onChangeAddress("addressString", e.target.value, 1, 'string')}/>
                                    {this.validateMessage('tWorkAdres') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tWorkAdres" delay={0}>
                                        {this.validateMessage("tWorkAdres")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İş Yeri İl/İlçe: </Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tWorkAdresCity')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="workAdresCity"
                                        id="tWorkAdresCity"
                                        style={{flex: 0.9}}
                                        /*
                                                                            options={this.props.cities.map(city => ({
                                                                                value: city.id,
                                                                                label: city.ad
                                                                            }))}*/
                                        options={this.state.workAdrsCities}
                                        onChange={(value) => this.onChangeAddress("cityId", value, 1, 'select')}
                                        value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].cityId}/>
                                    {this.validateMessage('tWorkAdresCity') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tWorkAdresCity" delay={0}>
                                        {this.validateMessage("tWorkAdresCity")}
                                    </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tWorkAdresCitySub')}>
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                        classNamePrefix="select"
                                        placeholder="İlçe seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="workAdresCitySub"
                                        id="tWorkAdresCitySub"
                                        style={{flex: 0.9}}
                                        options={this.state.workAdrsCitySubdivisions}
                                        onChange={(value) => this.onChangeAddress("citysubdivisionId", value, 1, 'select')}
                                        value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].citysubdivisionId}/>
                                    {this.validateMessage('tWorkAdresCitySub') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tWorkAdresCitySub" delay={0}>
                                        {this.validateMessage("tWorkAdresCitySub")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Semt: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tWorkSemt')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="workSemt"
                                           id="tWorkSemt"
                                           maxLength="20"
                                           value={this.state.memberInfo.addressList[1] && this.state.memberInfo.addressList[1].semt}
                                           onChange={(e) => this.onChangeAddress("semt", e.target.value, 1, 'string')}/>
                                    {this.validateMessage('tWorkSemt') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tWorkSemt" delay={0}>
                                        {this.validateMessage("tWorkSemt")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Müessese Ruhsatnamesi Belge No/Tarih:</Label>
                                <div className={"col-sm-4 form-group" + this.validateClass('tRuhsatNo')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="ruhsatNo"
                                           id="tRuhsatNo"
                                           maxLength="50"
                                           style={{flex: 1}}
                                           value={this.state.memberInfo.ruhsatNo || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("ruhsatNo", e.target.value)}/>
                                    {this.validateMessage('tRuhsatNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tRuhsatNo" delay={0}>
                                        {this.validateMessage("tRuhsatNo")}
                                    </UncontrolledTooltip>}
                                </div>
                                <div className={"col-sm-4 form-group" + this.validateClass('tRuhsatTarihi')}>
                                    <DatePicker {...tRuhsatTarihi}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="ruhsatTarihi"
                                                id="tRuhsatTarihi"
                                                style={{flex: 1}}
                                                onChange={(date, dateString) => this.onChangeDateString("ruhsatTarihi", dateString)}/>
                                    {this.validateMessage('tRuhsatTarihi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tRuhsatTarihi" delay={0}>
                                        {this.validateMessage("tRuhsatTarihi")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Vergi Dairesi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tVergiDairesiAd')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="vergiDairesiAd"
                                           id="tVergiDairesiAd"
                                           maxLength="50"
                                           value={this.state.memberInfo.vergiDairesiAd || ""}
                                           onChange={(e) => this.onChangeMemberUpperCase("vergiDairesiAd", e.target.value)}/>
                                    {this.validateMessage('tVergiDairesiAd') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tVergiDairesiAd" delay={0}>
                                        {this.validateMessage("tVergiDairesiAd")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Vergi No:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('tVergiNo')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={this.state.fieldsDisabled || !this.state.memberInfo.uyeCalisiyor}
                                           name="tVergiNo"
                                           id="tVergiNo"
                                           maxLength="50"
                                           value={this.state.memberInfo.vergiNo || ""}
                                           onChange={(e) => this.onChangeMember("vergiNo", e.target.value)}/>
                                    {this.validateMessage('tVergiNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tVergiNo" delay={0}>
                                        {this.validateMessage("tVergiNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Dosya Yükleme</span>
                            <div className="row">
                                <Label className="col-sm-3">Fotoğraf: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="fotoFile"
                                               thumbFileName="fotoThumbFile"
                                               filePathName="fotoPath"
                                               pathPrefix="foto"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.fotoPath}
                                               file={this.state.memberInfo.fotoFile}
                                               thumb={this.state.memberInfo.fotoThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Nüfus Cüz. Sureti: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="kimlikCuzdanFile"
                                               thumbFileName="kimlikCuzdanThumbFile"
                                               filePathName="kimlikCuzdanPath"
                                               pathPrefix="kimlik"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.kimlikCuzdanPath}
                                               file={this.state.memberInfo.kimlikCuzdanFile}
                                               thumb={this.state.memberInfo.kimlikCuzdanThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Adli Sicil Belgesi: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="adliSicilFile"
                                               thumbFileName="adliSicilThumbFile"
                                               filePathName="adliSicilPath"
                                               pathPrefix="adlisicil"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.adliSicilPath}
                                               file={this.state.memberInfo.adliSicilFile}
                                               thumb={this.state.memberInfo.adliSicilThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Müessese Ruhsatnamesi:</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="ruhsatnameFile"
                                               thumbFileName="ruhsatnameThumbFile"
                                               filePathName="ruhsatnamePath"
                                               pathPrefix="ruhsat"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.ruhsatnamePath}
                                               file={this.state.memberInfo.ruhsatnameFile}
                                               thumb={this.state.memberInfo.ruhsatnameThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Diploma Ruhsatnamesi:</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="diplomaFile"
                                               thumbFileName="diplomaThumbFile"
                                               filePathName="diplomaPath"
                                               pathPrefix="diploma"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.diplomaPath}
                                               file={this.state.memberInfo.diplomaFile}
                                               thumb={this.state.memberInfo.diplomaThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İkametgah: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="ikametgahFile"
                                               thumbFileName="ikametgahThumbFile"
                                               filePathName="ikametgahPath"
                                               pathPrefix="ikametgah"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.ikametgahPath}
                                               file={this.state.memberInfo.ikametgahFile}
                                               thumb={this.state.memberInfo.ikametgahThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>

                            {this.state.memberInfo.calismaBelgeli &&
                            <div className="row">
                                <Label className="col-sm-3">Çalışma Belgesi: *</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2 onInfoChange={this.onChangeMember}
                                               fileName="calismaBelgesiFile"
                                               thumbFileName="calismaBelgesiThumbFile"
                                               filePathName="calismaBelgesiPath"
                                               pathPrefix="calismaBelgesi"
                                               memberTCKN={this.state.memberInfo.tcKimlikNo}
                                               filePath={this.state.memberInfo.calismaBelgesiPath}
                                               file={this.state.memberInfo.calismaBelgesiFile}
                                               thumb={this.state.memberInfo.calismaBelgesiThumbFile}
                                               isDisabled={this.state.fieldsDisabled}/>
                                </div>
                            </div>
                            }
                        </div>

                        {
                            (this.state.mode === 'review')
                                ?
                                <div className="row">
                                    <Label className="col-sm-3">Reddedilme Nedeni: *</Label>
                                    <div
                                        className={"col-sm-8 form-group" + this.validateClass('tBasvuruReddedilmeSebebi')}>
                                        <TextArea className="form-control"
                                                  type="text"
                                                  name="basvuruReddedilmeSebebi"
                                                  id="tBasvuruReddedilmeSebebi"
                                                  maxLength="255"
                                                  value={this.state.memberInfo.basvuruReddedilmeSebebi}
                                                  onChange={(e) => this.onChangeMemberUpperCase("basvuruReddedilmeSebebi", e.target.value)}/>
                                        {this.validateMessage('tBasvuruReddedilmeSebebi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tBasvuruReddedilmeSebebi"
                                                             delay={0}>
                                            {this.validateMessage("tBasvuruReddedilmeSebebi")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                                :
                                ""
                        }
                    </Form>
                    {
                        (this.state.mode === 'review')
                            ?
                            <div className="row">
                                <div className="col">
                                    {
                                        (this.state.memberInfo.basvuruDurumu !== 'ONAYLANDI')
                                            ?
                                            <button style={{background: "#9dbef3"}} onClick={() => {
                                                this.saveMember("ONAYLA")
                                            }} className="login-form-button">ONAYLA</button>
                                            :
                                            ""
                                    }
                                </div>
                                <div className="col">
                                    {
                                        (this.state.memberInfo.basvuruDurumu !== 'ONAYLANDI')
                                            ?
                                            <button type="default" style={{background: "#a0d037"}} size="small"
                                                    onClick={() => {
                                                        this.saveMember("IADE")
                                                    }} className="login-form-button">İADE ET</button>
                                            :
                                            ""
                                    }
                                </div>
                                <div className="col">
                                    {
                                        (this.state.memberInfo.basvuruDurumu !== 'ONAYLANDI')
                                            ?
                                            <button style={{background: "#f39d9d"}} onClick={() => {
                                                this.saveMember("RED")
                                            }} className="login-form-button">REDDET</button>
                                            :
                                            ""
                                    }
                                </div>
                            </div>
                            :
                            <div className="save-button-container">
                                <button onClick={() => {
                                    this.saveMember("KAYDET")
                                }}
                                        className="member-save-button"
                                        disabled={this.state.isLoading || this.state.memberInfo.isTransferred}
                                >Üye Oluştur
                                </button>
                            </div>
                    }
                </div>

                <Modal isOpen={this.state.inActivateMemberModal} size="lg" className="ust">
                    <ModalHeader toggle={() => this.setState({inActivateMemberModal: false})}>
                        Uyarı
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <InActivateMemberModal
                            close={() => this.setState({inActivateMemberModal: false})}
                            inActivate={() => this.onChangeCheck("uyelikAktif", false)}
                            message={"Üyenin Oda İlişiği Kesilir ve 'KAYDET' e Tıklanırsa, İlişik Tekrar Aktif Hale Getirilemez! Devam Etmek İstiyor musunuz?"}
                        />
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default MemberCreate;



// WEBPACK FOOTER //
// ./src/page/memberList/MemberCreate.js